<template>
  <v-container style="margin-bottom: 10%; min-height: 100%">
    <v-flex>
      <v-layout>
        <v-card width="100%">
          <v-card-title>
            <v-autocomplete
              :items="courtList"
              v-model="courtSelected"
              @change="updateSelections"
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-dialog v-model="courtDiag" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  >Generar corte</v-btn
                >
              </template>
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="auto" sm="30" md="40">
                        <v-text-field
                          v-model="editedItem.low"
                          label="Año de inicio"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="auto" sm="30" md="40">
                        <v-text-field
                          v-model="editedItem.high"
                          label="Año de cierre"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#015CAB"
                    text
                    @click="generateCourt(editedItem.low, editedItem.high)"
                    >Generar</v-btn
                  >
                  <v-btn color="#E1251B" text @click="close">Cancelar</v-btn>
                </v-card-actions>
                <v-alert type="error" :value="unvalid"
                  >No se pudo generar el corte</v-alert
                >
              </v-card>
            </v-dialog>
          </v-card-title>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
            <v-btn
              color="#015CAB"
              style="color: white"
              @click="download(courtSelected)"
            >
              Descargar excel
            </v-btn>
          </v-card-title>

          <v-data-table
            style="width: 100%"
            ref="table"
            :headers="headers"
            :items="forms"
            :items-per-page="5"
            :rows-per-page="20"
            :search="search"
            :loading="loading"
            @click:row="viewForm"
          />
        </v-card>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import {
  getCourts,
  getFormsInCourt,
  downloadCourt,
  generateCourt,
} from "@/utils/apiRequest.js";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      forms: [],
      admin: false,
      courtDiag: false,
      search: "",
      unvalid: false,
      loading: false,
      statusMap: new Map(),
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        { text: "Nombre del R.A", value: "name" },
        { text: "Dominio del R.A", value: "domain" },
        { text: "Subdominio del R.A", value: "subdomain" },
        {
          text: "Sector",
          value: "sector",
        },
        { text: "Fecha de creación", value: "date" },
        { text: "Fecha de actualización", value: "updateDate" },
        { text: "Responsable de la digitación", value: "user.userName" },
        {
          text: "Responsable de la validación",
          value: "responsable.userName",
        },

        { text: "Estatus", value: "status" },
      ],
      courtList: [],
      courtSelected: "",
      court: {},
      editedItem: {
        low: "",
        high: "",
      },
      defaultItem: {
        low: "",
        high: "",
      },
    };
  },
  async mounted() {
    this.statusMap.set("summited", "digitado sin validar");
    this.statusMap.set("approved", "digitado validado");
    this.statusMap.set("published", "validado para publicación");
    this.statusMap.set("rejected", "rechazado");

    let response = await getCourts();
    if (response.data.status == "success") {
      response.data.cortes.forEach((court) => {
        this.courtList.push(court.name);
      });
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    getAnswer(form, text) {
      let ans = form.answers.find((element) => element.question == text);
      if (ans != undefined) {
        return ans.answer;
      }

      return "";
    },
    close() {
      this.courtDiag = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async updateSelections() {
      this.loading = true;
      let response = await getFormsInCourt(this.courtSelected);
      if (response.data.status == "success") {
        this.forms = response.data.forms;
        this.forms.forEach((form) => {
          form.domain = this.getAnswer(form, "Dominio actividad estadística");
          form.subdomain = this.getAnswer(
            form,
            "Subdominio de la actividad estadística"
          );
          form.goal = this.getAnswer(form, "¿Cuál es el objetivo del R.A?");
          form.observationUnit = this.getAnswer(
            form,
            "¿Cuál(es) es (son) la (s) unidad (es) de observación del R.A?"
          );
          form.name = this.getAnswer(
            form,
            "Nombre del Registro Administrativo"
          );
          form.sector = this.getAnswer(form, "sector");
          let date = new Date(form.updateDate);
          form.updateDate = date.toLocaleString();

          date = new Date(form.date);
          form.date = date.toLocaleString();
          form.status = this.statusMap.get(form.status);
        });
        this.loading = false;
      }

      this.loading = false;
    },
    async generateCourt(low, high) {
      var formData = new FormData();
      formData.append("lowYear", low);
      formData.append("highYear", high);
      let response = await generateCourt(formData);
      if (response.status != 200) {
        this.unvalid = true;
      }
      this.courtList.push(low + "-" + high);
      this.courtDiag = false;
    },
    viewForm(form) {
      try {
        const path = `/cortes/${form.code}`;
        window.open(path, "_blank");
      } catch (error) {
        console.log(error);
      }
    },
    enableApprove(status) {
      if (status != "approved" && this.admin) {
        return true;
      }
      return false;
    },
    enableReject(status) {
      if (status != "rejected" && this.admin) {
        return true;
      }
      return false;
    },
    async download(court) {
      let downloaded = await downloadCourt(court);
      if (downloaded.status != 200) {
        return;
      }
      var today = new Date();

      var date =
        today.getFullYear().toString() +
        (today.getMonth() + 1).toString() +
        today.getDate().toString();

      var time =
        today.getHours().toString() +
        today.getMinutes().toString() +
        today.getSeconds().toString();

      var dateTime = date + time;
      FileSaver.saveAs(downloaded.data, `IRRAAdata-${dateTime}.xlsx`);
    },
  },
};
</script>

<style scoped>
.centered {
  align-items: center;
  align-content: center;
  align-self: center;
}
.masterCard {
  align-self: center;
  margin: 0 auto;
}

.loading {
  margin: 0 0 0 0;
}
</style>